import type { FreeBet } from 'app/api/services/freebets/types';
import type { ReduxAction } from 'app/redux/types';

import { createHttpApiService, ServiceResponse } from 'app/api';
import { getUniversalUrl } from 'app/lib/get-universal-url';

import type { PledgeStakeDAO, PledgeStakesDAO } from '../types/backend/paymentOptions';

// --- PLEDGE STAKES

export type FetchPledgeStakesPayload = {
  bets: {
    id: number;
    matchId: number;
    price: number;
  }[];
};

export const fetchPledgeStakes = (
  controller: AbortController,
  payload?: FetchPledgeStakesPayload,
): ServiceResponse<PledgeStakesDAO> => (
  createHttpApiService({ signal: controller.signal }).post(getUniversalUrl('/api/bet-slip/get-possible-pledge-stakes'), payload)
);

// ---

export const SET_PLEDGE_STAKE = 'BET_SLIP:SET_PLEDGE_STAKE';

export type SetPledgeStake = ReduxAction<typeof SET_PLEDGE_STAKE, {
  betId: number;
  entry: PledgeStakeDAO;
}>;

export const setPledgeStake = (betId: number, entry: PledgeStakeDAO): SetPledgeStake => ({
  type: SET_PLEDGE_STAKE,
  payload: { betId, entry },
});

// ---

export const REMOVE_PLEDGE_STAKE = 'BET_SLIP:REMOVE_PLEDGE_STAKE';

export type RemovePledgeStake = ReduxAction<typeof REMOVE_PLEDGE_STAKE, {
  betId: number;
}>;

export const removePledgeStake = (betId: number): RemovePledgeStake => ({
  type: REMOVE_PLEDGE_STAKE,
  payload: { betId },
});

// --- FREE BETS

export const SET_FREE_BET = 'BET_SLIP:SET_FREE_BET';

export type SetFreeBet = ReduxAction<typeof SET_FREE_BET, {
  betId: number;
  entry: FreeBet;
}>;

export const setFreeBet = (betId: number, entry: FreeBet): SetFreeBet => ({
  type: SET_FREE_BET,
  payload: { betId, entry },
});

// ---

export const REMOVE_FREE_BET = 'BET_SLIP:REMOVE_FREE_BET';

export type RemoveFreeBet = ReduxAction<typeof REMOVE_FREE_BET, {
  betId: number;
}>;

export const removeFreeBet = (betId: number): RemoveFreeBet => ({
  type: REMOVE_FREE_BET,
  payload: { betId },
});

